import Icon from "@pdfking/workflow/components/Icon"
import { defineComponent } from "vue"
import can_hover from "../features/can_hover"
import close from "../mixins/Close"
import get_route_props from "../routes/get_route_props"
import navigate from "../routes/navigate"
import { SEARCH_VIEW } from "../routes/urls"
import keyboard from "../state/keyboard"
import user from "../state/user"

export default defineComponent({
  beforeUnmount() {
    document.removeEventListener("focus_search", this.focus_search)
  },
  computed: {
    full_placeholder() {
      return (user as any).is_staff
        ? `${this.placeholder} (⌘K)`
        : this.placeholder
    },
    query() {
      if (this.$route.name == SEARCH_VIEW) {
        // @ts-expect-error - route props type
        return get_route_props(this.$route).query
      }
      return null
    },
  },
  methods: {
    focus_search() {
      if (can_hover()) {
        ;(this.$refs.input as HTMLInputElement).focus()
      }
    },
    keypress(event: KeyboardEvent) {
      if ((event.metaKey || event.ctrlKey) && event.key.toLowerCase() === "k")
        (this.$refs.input as HTMLInputElement).focus()
    },
    searchinput(e: Event) {
      const query = (e.target as HTMLInputElement).value

      if (query) {
        navigate(SEARCH_VIEW, { query })
      } else {
        this.close()
      }
    },
    searchsubmit() {
      navigate(SEARCH_VIEW, {
        query: (this.$refs.input as HTMLInputElement).value,
        send: 1,
      })
    },
  },
  mixins: [close],
  mounted() {
    ;(keyboard as any).register(this.keypress)
    document.addEventListener("focus_search", this.focus_search)
  },
  props: ["placeholder"] as const,
  render() {
    return (
      <form
        class="w-100 position-relative"
        onSubmit={(e: Event) => {
          e.stopPropagation()
          e.preventDefault()
          this.searchsubmit()
        }}
      >
        <input
          ref="input"
          autocomplete="off"
          class="form-control publicsearch"
          placeholder={this.full_placeholder}
          style="padding-left: 40px"
          type="search"
          value={this.query}
          onInput={this.searchinput}
        />
        <Icon
          class="position-absolute top-50 translate-middle-y start-0 ms-3"
          name="SEARCH"
        />
      </form>
    )
  },
})
